import { AuthenticationStore } from '@/state/authentication.store';
import { Injectable, effect, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationNavigationService {
  private readonly authenticationStore = inject(AuthenticationStore);
  private readonly router = inject(Router);

  constructor() {
    let wasLoggedIn = this.authenticationStore.isLoggedIn();

    effect(() => {
      const isLoggedIn = this.authenticationStore.isLoggedIn();

      if (wasLoggedIn && !isLoggedIn && this.router.url !== '/auth/login') {
        void this.router.navigateByUrl('/auth/login');
      }

      wasLoggedIn = isLoggedIn;
    });
  }
}
